import { API_BASE_URL, API_LOCAL_URL, API_NODE_URL } from '~/constants';
import api from '~/services/api';

class DocumentoSaidaService {
  _strategy = null;

  constructor() {
    this._strategy = new DocumentoSaidaOnlineService();
  }

  setStategy(isOffline = false) {
    this._strategy = isOffline
      ? new DocumentoSaidaOfflineService()
      : new DocumentoSaidaOnlineService();
  }

  getAll(payload) {
    return this._strategy.getAll(payload);
  }

  getId(id) {
    return this._strategy.getId(id);
  }

  getTotalizadores() {
    return this._strategy.getTotalizadores();
  }

  syncManual() {
    return this._strategy.syncManual();
  }
}

export class DocumentoSaidaOnlineService {
  getAll({ status, filtroData, offset, limit }, opts) {
    return api.get(
      `${API_NODE_URL}/faturamento/documento-saida/monitor-nfce/${status}/${filtroData}/${offset}/${limit}`,
      opts
    );
  }

  getAllDocumentos( payload, opts) {
    const params = {
      $top: payload.limit ? payload.limit : 100,
      $skip: payload.offset,
      $orderby: payload.orderby ? payload.orderby : 'logCriacao desc',
      $select: [
        'id',
        'documentoSerie',
        'documentoNumero',
        'documentoDataEmissao',
        'documentoFinalidade',
        'documentoModelo',
        'documentoImpresso',
        'documentoTransmissao',
        'documentoCancelado',
        'nfeChave',
        'clienteNome',
        'clienteCpfCnpj',
        'clienteTelefone',
        'valorTotal',
        'logCriacao',
        'logAtualizacao',
        'entregaUf',
        'entregaCep',
        'entregaLogradouro',
        'entregaLogradouroNumero',
        'entregaComplemento',
        'entregaBairro',
        'entregaIntCidadeId',
        'enderecoUf',
        'enderecoCep',
        'enderecoLogradouro',
        'enderecoLogradouroNumero',
        'enderecoComplemento',
        'enderecoBairro',
        'informacaoComplementar',
        'logAtualizacao',
        'entregaUf',
        'entregaCep',
        'entregaLogradouro',
        'entregaLogradouroNumero',
        'entregaComplemento',
        'entregaBairro',
        'entregaIntCidadeId',
        'enderecoUf',
        'enderecoCep',
        'enderecoLogradouro',
        'enderecoLogradouroNumero',
        'enderecoComplemento',
        'enderecoBairro',
        'informacaoComplementar',
        'intAssinaturaId'
      ].join(','),
      $expand: [
        'fisOperacao($select=descricao)',
        'fatVendedor($select=nome)',
        'fatCondicaopagamento($select=descricao)',
        'intCliente($select=razaoSocial,telefone,celular,pjCnpj,pfCpf,email,codigoInterno)',
        'enderecoIntCidade',
        'entregaIntCidade',
        'fatTabelavenda($select=descricao)',
        'itens($select=produtoCodigo,produtoDescricao,produtoUnidadeComercial,itemValorUnitario,itemValorBruto,itemValorAcrescimoCondicao,itemQuantidade,itemValorDesconto,itemValorAcrescimo,itemValorFrete,itemValorSeguro,itemValorDespesa,itemValorTotal,itemOrdem,itemCancelado,produtoEstProdutoId,estProdutoAmbienteId;$expand=produtoEstProduto($select=id,foto),estProdutoAmbiente($select=id,descricao))',
        'parcelas($expand=finMeiopagamento,fatCartaobandeira)',
        'intAssinatura($select=id,assinatura,logAtualizacao)',
      ].join(',')
    };
    return api.get(
      `${API_BASE_URL}/v1/faturamento/documentosaida/`,
      {
        params:
        payload.filter?.length > 0 ? { ...params, $filter: [...payload.filter]?.join(` and `) } : { ...params },
        ...opts
      }
    );
  }

  getImportacaoSearch({offset, limit, pesquisaPor, tempo, filtroFilial}, opts) {
    return api.post(`${API_NODE_URL}/pdv/documentosaida/importacao/search`, {
      offset,
      limit,
      pesquisaPor,
      tempo,
      filtroFilial
    });
  }

  getImportacao({ offset, limit, filtros = [], page }, opts) {
    const params = {
      offset,
      limit,
      page
    };
    return api.get(`${API_NODE_URL}/faturamento/documento-saida/importacao/paginado`, {
      params: {
        ...params,
        filtros: JSON.stringify(filtros)
      }
    });
  }

  getId(id) {
    return api.get(`${API_BASE_URL}/v1/faturamento/documentosaida/${id}`);
  }

  getTotalizadores(filtroData = '', pesquisaPor = '', opts) {
    return api.post(
      `${API_NODE_URL}/pdv/documentosaida/totalizadores`,
      {
        tempo: filtroData ?? '',
        pesquisaPor: pesquisaPor ?? '',
      },
      opts
    );
  }
}

export class DocumentoSaidaOfflineService {
  syncManual(payload) {
    return api.post(`${API_LOCAL_URL}/sync/documentosaida`, payload);
  }
  getAll(opts) {
    return api.get(`${API_LOCAL_URL}/faturamento/documentosaida`, opts);
  }

  getId(id) {}

  getTotalizadores() {}
}

export default new DocumentoSaidaService();
